// eslint-disable-next-line
function onSubmit(token) {
  if (token) {
    $('button[type=submit]').prop('disabled', true);
    $('form[data-recaptcha-form=true]').submit();
  }
}
